var React = require('react');

function RedCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_15","data-name":"Path 15","d":"M58.589,107.382H52.824c-.29-.045-.578-.1-.869-.133-2.174-.252-4.373-.37-6.519-.77q-22.865-4.264-31.458-25.91a53.121,53.121,0,0,1-3.159-25.174,54.386,54.386,0,0,1,6.406-21.26c9.294-16.741,23.459-24.816,42.692-23.5a60.838,60.838,0,0,1,19.874,5.009,47.338,47.338,0,0,1,19.48,14.683c8.4,11,10.879,23.432,8.158,36.85-4.18,20.607-20.88,37.063-44.367,39.752C61.574,107.1,60.08,107.233,58.589,107.382Z","transform":"translate(-8.002 -7.997)","fill":"none","stroke":"#9f0519","strokeMiterlimit":"10","strokeWidth":"5"}));
}

RedCircleInline.defaultProps = {"viewBox":"0 0 102.996 101.885"};

module.exports = RedCircleInline;

RedCircleInline.default = RedCircleInline;
